import { TableCell, TableRow } from '@mui/material';
import { getPersonalDataMuiBodyCellSx, personalDataMuiRowSx } from '../styles.ts';
import { TPersonalDataMuiColumn } from '../types.ts';

const getRecordValue = (record: object, key: string): unknown =>
  (record as Record<string, unknown>)[key];

const getCellAlign = (
  columnAlign: 'left' | 'center' | 'right' | undefined,
  cellTextAlign: unknown
): 'left' | 'center' | 'right' => {
  if (columnAlign) {
    return columnAlign;
  }

  return cellTextAlign === 'center' || cellTextAlign === 'right' ? cellTextAlign : 'left';
};

interface IPersonalDataBodyRowProps<TRecord extends object> {
  rowKey: string;
  rowIndex: number;
  record: TRecord;
  columns: TPersonalDataMuiColumn<TRecord>[];
}

export const PersonalDataMuiTableBodyRow = <TRecord extends object>({
  rowKey,
  rowIndex,
  record,
  columns,
}: IPersonalDataBodyRowProps<TRecord>) => (
  <TableRow key={String(getRecordValue(record, rowKey) ?? rowIndex)} hover sx={personalDataMuiRowSx}>
    {columns.map((column) => {
      const rawValue = getRecordValue(record, column.dataIndex);
      const renderedValue = column.render ? column.render(rawValue, record) : String(rawValue ?? '');
      const cellConfig = column.onCell?.(record, rowIndex);
      const cellStyle = cellConfig?.style || {};

      return (
        <TableCell
          key={column.key}
          align={getCellAlign(column.align, cellStyle.textAlign)}
          style={cellStyle}
          sx={getPersonalDataMuiBodyCellSx(column.width)}
        >
          {renderedValue}
        </TableCell>
      );
    })}
  </TableRow>
);
